import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";
import { PhotoSlot } from "@/components/site/PhotoSlot";
import { QuoteButton } from "@/components/site/Cta";
import { Reveal } from "@/components/site/Reveal";
import { WHY_POINTS, PHOTOS } from "@/content/site";

export const WhyChoose = () => {
  return (
    <section data-testid="why-section" className="relative bg-[#08090a] py-24 sm:py-32">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-12">
        <Reveal className="relative flex flex-col justify-center">
          <div className="relative overflow-hidden rounded-[28px] border border-white/10">
            <PhotoSlot src={PHOTOS.technician} alt="Solar Energy Doc technician working on solar equipment in Texas" label="Technician at work" className="aspect-[16/9] w-full" testId="why-photo" />
          </div>
          <div className="glass mt-4 rounded-2xl p-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-amber-400">Our Philosophy</p>
            <p className="mt-2 font-display text-sm leading-snug text-white">We don't just install solar — we understand the technology behind it.</p>
          </div>
        </Reveal>
        <div className="flex flex-col justify-center pt-6 lg:pt-0">
          <SectionHead index="03" eyebrow="Why Solar Energy Doc" lines={["Why Texas homeowners", "choose Solar Energy Doc"]} />
          <Reveal delay={0.1} as="p" className="mt-6 text-lg font-medium text-white">We don't just install solar—we understand the technology behind it.</Reveal>
          <Reveal delay={0.15} as="p" className="mt-4 text-base leading-relaxed text-zinc-300">
            From new installations to troubleshooting existing systems, Solar Energy Doc provides dependable solar and electrical solutions designed to keep your energy system working the way it should.
          </Reveal>
          <ul className="mt-10 grid gap-x-8 gap-y-0 sm:grid-cols-2" data-testid="why-points">
            {WHY_POINTS.map((p, i) => (
              <motion.li key={p} initial={{ opacity: 0, x: -12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.6, delay: i * 0.04 }} className="flex items-center gap-3 border-b border-white/8 py-3.5">
                <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-amber-400/15"><Check className="h-3.5 w-3.5 text-amber-400" /></span>
                <span className="text-sm font-medium text-zinc-100">{p}</span>
              </motion.li>
            ))}
          </ul>
          <div className="mt-10"><QuoteButton testId="why-cta-quote">Talk to a Solar Expert</QuoteButton></div>
        </div>
      </div>
    </section>
  );
};
